<template>
  <loading :active="true"
                 :loader="'dots'"
                 :color="'#00AB00'"
                 :can-cancel="false"
                 :is-full-page="true"/>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
  components: {
    Loading,
  },
  computed: {
    loading: {
      get() {
        return this.$store.state.LoadingOverlay;
      },
      set(val) {
        this.$store.commit("LoadingOverlay", val);
      },
    },
  },
};
</script>
